import * as THREE from "three";

function meshMatches(childName, patterns) {
  return patterns.some(
    (p) => childName === p || new RegExp(`^${p}_\\d+$`).test(childName),
  );
}

export function setMeshVisibility(scene, meshNames, visible) {
  scene.traverse((child) => {
    if (child.isMesh && meshMatches(child.name, meshNames)) child.visible = visible;
  });
}

export function applyColor(scene, meshNames, { hex, roughness, metalness }) {
  const color = new THREE.Color(hex);

  scene.traverse((child) => {
    if (!child.isMesh || !meshMatches(child.name, meshNames)) return;

    const applyToMat = (m) => {
      const c = m.clone();
      c.map = null;
      c.color.copy(color);
      c.roughness = roughness;
      c.metalness = metalness;
      c.needsUpdate = true;
      return c;
    };

    child.material = Array.isArray(child.material)
      ? child.material.map(applyToMat)
      : applyToMat(child.material);
  });
}

export function applyTexture(scene, meshNames, texture, overrides = {}) {
  scene.traverse((child) => {
    if (!child.isMesh || !meshMatches(child.name, meshNames)) return;

    const applyToMat = (m) => {
      const t = texture.clone();
      t.colorSpace = THREE.SRGBColorSpace;
      if (m.map) {
        t.wrapS = m.map.wrapS;
        t.wrapT = m.map.wrapT;
        t.repeat.copy(m.map.repeat);
        t.offset.copy(m.map.offset);
        t.rotation = m.map.rotation;
        t.center.copy(m.map.center);
        t.updateMatrix();
      } else {
        t.wrapS = THREE.RepeatWrapping;
        t.wrapT = THREE.RepeatWrapping;
      }

      const c = m.clone();
      c.map = t;
      c.color.set(0xffffff);
      if (overrides.roughness !== undefined) c.roughness = overrides.roughness;
      if (overrides.metalness !== undefined) c.metalness = overrides.metalness;
      c.needsUpdate = true;
      return c;
    };

    child.material = Array.isArray(child.material)
      ? child.material.map(applyToMat)
      : applyToMat(child.material);
  });
}
